module.exports = "<app-header></app-header>\r\n<app-navigation></app-navigation>\r\n<div class=\"shadow\"></div>\r\n<router-outlet></router-outlet>\r\n<app-contact-info-section></app-contact-info-section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 767
// module chunks = 1